import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import HeroSection from '@/components/landing/hero-section'
import CountdownSection from '@/components/landing/countdown-section'
import MessageSection from '@/components/landing/message-section'
import ProgramSection from '@/components/landing/program-section'
import DetailsSection from '@/components/landing/details-section'
import RsvpSection from '@/components/landing/rsvp-section'
import FaqSection from '@/components/landing/faq-section'

interface HomeProps {
    shareImage: string | null
}

const SHARE_IMAGE_PATH = '/images/partage.jpg'
const SAFE_HOST = /^[a-z0-9.-]+(:\d+)?$/i

const firstHeaderValue = (value: string | Array<string> | undefined): string | undefined =>
    (Array.isArray(value) ? value[0] : value)?.split(',')[0]?.trim() || undefined

// Link previews (WhatsApp, Messenger, iMessage) need an absolute image address, built from the address the visitor used.
export const getServerSideProps: GetServerSideProps<HomeProps> = async ({ req }) => {
    const host = firstHeaderValue(req.headers['x-forwarded-host']) ?? firstHeaderValue(req.headers.host)
    const protocol = firstHeaderValue(req.headers['x-forwarded-proto']) === 'http' ? 'http' : 'https'

    const shareImage = host && SAFE_HOST.test(host)
        ? `${protocol}://${host}/_next/image?url=${encodeURIComponent(SHARE_IMAGE_PATH)}&w=1200&q=75`
        : null

    return { props: { shareImage } }
}

const Home: FC<HomeProps> = ({ shareImage }): ReactNode => {
    return (
        <Layout>
            <Seo ogImage={shareImage ?? undefined} />

            <HeroSection />
            <CountdownSection />
            <MessageSection />
            <ProgramSection />
            <DetailsSection />
            <RsvpSection />
            <FaqSection />
        </Layout>
    )
}

export default Home
